import { createSlice } from '@reduxjs/toolkit'

const distinteSlice = createSlice({
  name: 'distinte',
  initialState: {},
  reducers: {
    setDistinta(state, action) {
      state.distinta = action.payload
    },
    setDistintaField(state, action) {
      if (!state.distinta) state.distinta = {}
      state.distinta[action.payload.field] = action.payload.value
    },
  },
})

export const { setDistinta, setDistintaField } = distinteSlice.actions

export default distinteSlice.reducer
